<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md12 lg12 xl12>
        <h2 class="pl-4">
          <span>Have a look on</span>
          <span class="blue--text"> some of my</span>
        </h2>
      </v-flex>
      <v-flex v-for="portfolio in portfolios" :key="portfolio.src" xs12 sm12 md12 lg12 xl4>
        <v-hover
        v-slot="{ hover }"
        open-delay="100"
      >
        <v-card
          to="/portfolio/web"
          :elevation="hover ? 24 : 6"
          :class="{ 'on-hover': hover }"
          flat
          color="transparent"
          height="230"
        >
          <v-card-title></v-card-title>
          <v-img src="https://i.imgur.com/GvTt5GG.png" aspect-ratio="2.75" height="110" contain lazy-src="https://unra.go.ug/assets/loaders/loader_2.gif"></v-img>
          <v-card-title primary-title class="justify-center">
            <v-flex text-xs-center subheading font-weight-bold>
              <span class="blue--text font-weight-medium">Web </span>Projects</v-flex>
          </v-card-title>
        </v-card>
        </v-hover>
      </v-flex>
<v-flex xs12 sm12 md12 lg12 xl4>
  <v-hover
        v-slot="{ hover }"
        open-delay="100"
      >
        <v-card
         to="/portfolio/graphic"
         :elevation="hover ? 24 : 6"
         hover
         flat
         color="transparent"
         height="230"
         >
          <v-card-title></v-card-title>
          <v-img src="https://i.imgur.com/g74mGuU.png" aspect-ratio="2.75" height="110" contain lazy-src="https://unra.go.ug/assets/loaders/loader_2.gif"></v-img>
          <v-card-title primary-title class="justify-center">
            <v-flex text-xs-center subheading font-weight-bold><span class="blue--text font-weight-medium">Graphic </span>Projects</v-flex>
          </v-card-title>
        </v-card>
  </v-hover>
</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: "Portfolio",
    titleTemplate: "%s ← Midhun Nair",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Midhun Nair's Portfolio Web Development Video Editing Graphic Design Front-End Advetising"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Midhun Nair" },
      { property: "og:site_name", content: "Midhun Nair" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "http://midhunnair.live" },
      {
        property: "og:image",
        content: "https://cdn.image4.io/mndesigns/f_auto/66aa3e55-542a-4355-acb3-2602e5d55414.png"
      },
      {
        property: "og:description",
        content:
          "Midhun Nair's Portfolio Web Development Video Editing Graphic Design Front-End Advetising"
      }
    ]
  },
  data() {
    return {
      portfolios: [
        {
          src: "https://i.imgur.com/GvTt5GG.png",
          title: "Have a look on some of My Web Projects"
        },
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>